import api from '@/services/api'
import { getOptionsString } from '@/services/api/helpers'

const associateAd = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

const createCampaign = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

const getAds = (path, options) => {
  return api.get(`${path}?${getOptionsString(options)}`).then(async ({data}) => {
    return data
  })
}

const getCPM = (campaignId) => {
  return api.get(`/analytics/campaigns?campaign=${campaignId}`).then(async ({data}) => {
    return data
  })
}

const getCampaign = (path) => {
  return api.get(path).then(async ({data}) => {
    return data
  })
}

const getCampaignTargets = (path) => {
  return api.get(path).then(async ({data}) => {
    return data
  })
}

const getCampaigns = (options) => {
  let optionsString = options ? getOptionsString(options) : ''

  return api.get(`/campaigns?fields=id,name,start_time,end_time,status,ad_types,labels,paused,priority,cpm_limit,markers&${optionsString}`).then(async ({data}) => {
    return data
  })
}

const getAccountCampaigns = (options, accountId) => {
  let optionsString = options ? getOptionsString(options) : ''

  return api.get(`/accounts/${accountId}/campaigns?fields=id,name,start_time,end_time,status,ad_types,labels,paused,priority,cpm_limit,markers&${optionsString}`).then(async ({data}) => {
    return data
  })
}

const getCampaignsOptions = (options, accountId) => {
  let optionsString = getOptionsString(options)
  let accountPath = accountId ? `/accounts/${accountId}` : ''
  let path = `${accountPath}/campaigns?${optionsString}`
  return api.get(path).then(async ({data}) => {
    return data
  })
}

const getTargets = (campaignId, accountId) => {
  let accountQuery = accountId ? `?account_id=${accountId}` : ''
  let path = `/campaigns/targets${accountQuery}`
  if (campaignId) path = `/campaigns/${campaignId}/targets`
  return api.get(path).then(async ({data}) => {
    return data
  })
}

const updateAdBlock = (path, payload) => {
  return api.post(path, payload).then(async ({data}) => {
    return data
  })
}

const deleteAdBlock = (path) => {
  return api.delete(path).then(async ({data}) => {
    return data
  })
}

const updateCampaign = (campaignId, payload) => {
  return api.post(`/campaigns/${campaignId}`, payload).then(async ({data}) => {
    return data
  })
}

const deleteCampaign = (campaignId) => {
  return api.delete(`/campaigns/${campaignId}`).then(({data}) => {
    return data
  })
}

export default {
  getAccountCampaigns,
  associateAd,
  createCampaign,
  deleteAdBlock,
  deleteCampaign,
  getAds,
  getCPM,
  getCampaign,
  getCampaigns,
  getCampaignTargets,
  getCampaignsOptions,
  getTargets,
  updateAdBlock,
  updateCampaign
}
